import React, { useState } from "react";
import "./mailbox_styles/newmail.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faStar,
    faTrash,
    faEllipsisVertical,
    faB,
    faItalic,
    faUnderline,
    faPaperclip,
    faImage,
    faPaperPlane
} from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";
import swal2 from "sweetalert";
import { emailsRef, serverTimestamp } from "../../firebase";
import { useSelector } from "react-redux";
import { getUsersCollectionIds } from "../../App";

const NewMail = () => {
    const usersData = useSelector((state) => state.userData);
    const [emailData, setEmailData] = useState({
        to: "",
        subject: "",
        email_body: "",
    })

    const inputEvent = (event) => {
        let { name, value } = event.target;
        setEmailData((preValue) => {
            return {
                ...preValue,
                [name]: value,
            }
        })
    }

    const handleEmailSend = async (event) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const all_email_ids = await getUsersCollectionIds();
        event.preventDefault();
        if (emailData.to === "") {
            return swal("Warning", "Please specify at least one recipient.", "warning");
        }
        if (emailData.to !== "" && !all_email_ids.includes(emailData.to)) {
            return swal("Warning", "Recipient User not found!", "warning");
        }
        if (emailData.subject === "") {
            return swal("Warning", "Please specify subject.", "warning");
        }
        if (emailData.email_body === "") {
            return swal("Warning", "Please specify email body.", "warning");
        }
        if (emailData.to !== "" && !regex.test(emailData.to)) {
            return swal("Warning", "Email id is not valid", "warning");
        }
        else {
            // console.log(emailData);
            await emailsRef.add({
                ...emailData,
                from_email: usersData.email,
                timestamp: serverTimestamp,
                opened: false
            })
                .then(() => {
                    swal2.fire({
                        icon: 'success',
                        title: `Email Sent !`,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    setEmailData({
                        to: "",
                        subject: "",
                        email_body: "",
                    });
                })
                .catch((error) => {
                    swal("Error", "Something went wrong !", "error");
                });
        }
    }

    return (
        <>
            <div className="newmail_container">
                <div className="newmail_headerbox">
                    <FontAwesomeIcon icon={faStar} className="icons" />
                    <FontAwesomeIcon icon={faTrash} className="icons" />
                    <FontAwesomeIcon icon={faEllipsisVertical} className="icons" />
                </div>

                <div className="parent_mail_container">
                    <div className="time_container">
                        <span className='meeting_card_time'>{new Date().toLocaleString('en-US', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true }).replace(/,/, '')}</span>
                    </div>
                    <div className="mail_title">
                        <input placeholder="To" onChange={inputEvent} name="to" value={emailData.to}></input>
                    </div>
                    <div className="mail_title">
                        <input placeholder="Subject" onChange={inputEvent} name="subject" value={emailData.subject}></input>
                    </div>

                    <div className="reply_mail_container">
                        <textarea className="replyMail_box" placeholder="Write your mail" onChange={inputEvent} name="email_body" value={emailData.email_body}></textarea>
                    </div>
                    <div className="text_design_container">
                        <button><FontAwesomeIcon icon={faB} className="icons" /></button>
                        <button><FontAwesomeIcon icon={faItalic} className="icons" /></button>
                        <button><FontAwesomeIcon icon={faUnderline} className="icons" /></button>
                        <button><FontAwesomeIcon icon={faPaperclip} className="icons" /></button>
                        <button><FontAwesomeIcon icon={faImage} className="icons" /></button>
                        <button><FontAwesomeIcon icon={faTrash} className="icons" /></button>
                    </div>
                    <div className="sendButton_container">
                        <button type="submit" onClick={handleEmailSend}>
                            <span>Send</span>
                            <FontAwesomeIcon icon={faPaperPlane} className="icons" />
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewMail;
